import { taggedTemplateLiteral as _taggedTemplateLiteral, slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import InputRange from '../../_virtual/index3.js';
import Theme from '../../Theme/index.js';

var _templateObject;
var InputRangeStyled = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  & div.input-range__track--active,\n  div.input-range__slider {\n    border: 1px solid ", ";\n    background: ", ";\n  }\n"])), Theme.colors.lightBlue, Theme.colors.lightBlue);
var SalaryRange = function SalaryRange(_ref) {
  var min = _ref.min,
    max = _ref.max,
    value = _ref.value,
    step = _ref.step,
    _onChange = _ref.onChange;
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    range = _useState2[0],
    setRange = _useState2[1];
  return /*#__PURE__*/React__default.createElement(InputRangeStyled, null, /*#__PURE__*/React__default.createElement(InputRange, {
    formatLabel: function formatLabel(value) {
      return "$ ".concat(value);
    },
    minValue: min,
    maxValue: max,
    value: range,
    step: step,
    onChange: function onChange(value) {
      setRange(value);
      _onChange(value);
    }
  }));
};
SalaryRange.displayName = "SalaryRange";
SalaryRange.propTypes = {
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.oneOf([PropTypes.objectOf({
    min: PropTypes.number,
    max: PropTypes.number
  }), PropTypes.number]),
  step: PropTypes.number,
  onChange: PropTypes.func
};

export { SalaryRange as default };
